var React = require('react');

function IconMapSettingsLockActive (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#30B4C0","d":"M20.256 7c4.597.023 8.254.681 8.254 5.35v3.441h2.383v17.402H9.107V15.791h2.383v-3.44C11.49 7.595 15.284 7 20 7zm-.1 14.267c-1.266 0-2.293 1.042-2.293 2.327a2.34 2.34 0 0 0 1.044 1.954v.374l-.248 3.27h2.995l-.249-3.27a2.28 2.28 0 0 0 0-.374 2.34 2.34 0 0 0 1.045-1.954c0-1.285-1.027-2.327-2.294-2.327zm-.14-11.354c-3.44-.131-5.16.682-5.16 2.44v3.422h10.32v-3.423c0-1.67-1.72-2.482-5.16-2.439z"}));
}

IconMapSettingsLockActive.defaultProps = {"width":"40","height":"40"};

module.exports = IconMapSettingsLockActive;

IconMapSettingsLockActive.default = IconMapSettingsLockActive;
